import routes from "../../../engine/routes";
import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { RenderMenuSider } from "../../../engine/AuthRoute/navigationHelper";
import { useSelector } from "react-redux";

export const PrincipalSlider = () => {
  const location = useLocation();

  const { id } = useParams();

  const { principal, loading } = useSelector(state => state.principal);

  const prestationDetailMenu = {
    title: id === "new" ? "Nouvelle principal" : principal.name,
    root: routes.principals,
    children: [
      routes.principals(id).detail,
      routes.principals(id).detailUsers,
      routes.principals(id).detailInstitutions,
      routes.principals(id).addresses,
    ],
  };

  return <RenderMenuSider menu={prestationDetailMenu} />;
};
